// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"708d65c6","453":"ebcaedf2","455":"f42f7e1a","977":"876ab9a7"}[chunkId] + ".chunk.js";
};